import { stepstampFromRoundStep } from '../../../data/lifespan/stepstamp.js';
import { Step } from '../enums.js';

const bootstrapRootFocusBoundary = stepstampFromRoundStep({
  round: 1,
  step: Step.Bootstrap,
});

if (bootstrapRootFocusBoundary == null) {
  throw new Error('Failed to compute the bootstrap root focus boundary');
}

export const BOOTSTRAP_ROOT_ROUND_FOCUS_UNTIL_STEPSTAMP = bootstrapRootFocusBoundary;

export function isRoundFocusedAt(input: {
  roundFocusUntilStepstamp: number | null;
  atStepstamp: number;
}): boolean {
  return input.roundFocusUntilStepstamp != null
    && input.atStepstamp < input.roundFocusUntilStepstamp;
}
